export enum InvoiceLineItemDiscountType {
    Percent = 0,
    Amount = 1,
    PercentAdditional = 2,
    AmountAdditional = 3,
}